<div class="h-100" [ngClass]="theme ? '': 'dark' ">
    <div class="container-fluid" [ngClass]="theme ? '': 'banner' ">
        <div class="row m-0 px-3 py-4">
            <div class="d-flex align-items-center justify-content-between py-3 px-0 border-bottom">
                <h1 class="fw-600 m-0 mx-3">Lists</h1>
                <div class="d-flex align-items-center">
                    <button class="btn btn-outline-primary me-2"><i class="bi bi-file-earmark-arrow-down iw-bold"></i>
                        Import</button>
                    <button class="btn btn-outline-primary ms-2" (click)="openModal(Create)"><i
                            class="bi bi-plus-lg iw-bold"></i> Create</button>
                </div>
            </div>
            <div>
                <table class="table hover" [ngClass]="theme ? '': 'dark-table' ">
                    <thead>
                        <tr class="table-content">
                            <th scope="col" class="fw-bold text-geay">List name</th>
                            <th scope="col" class="fw-bold text-geay">Number of item</th>
                            <th scope="col" class="fw-bold text-geay">Not completed keyword</th>
                            <th scope="col" class="fw-bold text-geay">Completed keyword</th>
                            <th scope="col" class="fw-bold text-geay">SERP Analysis</th>
                            <th scope="col" class="fw-bold text-geay">Edit</th>
                            <th scope="col" class="fw-bold text-geay">Delete</th>
                        </tr>
                    </thead>
                    <tbody class="align-middle">
                        <tr *ngFor="let data of paginateData;let i = index">
                            <td class="py-3 fw-bold" (click)="openKeywordDetails()" role="button">{{data.name}}
                            </td>
                            <td class="text-center">{{data.numberOfItem}}</td>
                            <td class="text-center">{{data.notCompletedKeyword}}
                                <a href="" class="text-decoration-none ps-2">
                                    <i class="bi bi-arrow-up-right"></i>
                                </a>
                            </td>
                            <td class="text-center">{{data.completedKeyWord}}
                                <a href="" class="text-decoration-none ps-2">
                                    <i class="bi bi-arrow-up-right"></i>
                                </a>
                            </td>

                            <td class="text-center z-index">
                                <i class="bi bi-arrow-repeat" (click)="openModal(SERPAnalyze)" role="button"></i>
                            </td>
                            <td class="text-center">
                                <i class="bi bi-pencil" (click)="openModal(Edit,data.name,i)" role="button"></i>
                            </td>
                            <td class="text-center">
                                <i class="bi bi-trash3" (click)="openModal(Delete,'',i)" role="button"></i>
                            </td>
                        </tr>

                        <!-- Modal For SERP Analyze -->
                        <ng-template #SERPAnalyze let-modal>
                            <div class="p-4 text-center">
                                <h2 class="fw-bold">SERP Analyze</h2>
                                <p class="fs-16 data-number">We are working on <span class="fw-bold">19 keywords</span>
                                </p>
                                <p class="fs-16 mb-4 data-number">This may take few minutes!</p>
                                <div>
                                    <span class="neutral-dark fs-12 d-flex text-start mb-1 neutral-gray">SERP Analyze
                                        ...</span>
                                    <div class="progress" role="progressbar" aria-label="Success example"
                                        aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                        <div class="progress-bar progressbar-cyan" style="width: 25%"></div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>

                        <!-- Modal For Edit -->
                        <ng-template #Edit let-modal>
                            <div class="p-4">
                                <div class="position-relative">
                                    <h2 class="text-center fw-bold">Edit list name</h2>
                                    <button type="button" class="position-absolute top-0 end-0 btn-close"
                                        aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
                                </div>
                                <div class="position-relative">
                                    <input type="text" [formControl]="editListName" class="input w-100 pe-36"
                                        placeholder="Enter list name">
                                    <i class="bi bi-x-circle-fill clear-icon" (click)="editListName.setValue('')"
                                        *ngIf="editListName.value !== ''" role="button"></i>
                                </div>
                                <div class="d-flex mt-4">
                                    <button type="button" class="btn btn-outline-primary me-1 w-50"
                                        (click)="modal.close('Close click')">Cancel</button>
                                    <button type="button" class="btn btn-primary ms-1 w-50" (click)="editNames()"
                                        [disabled]="editListName.value == ''">Apply</button>
                                </div>
                            </div>
                        </ng-template>

                        <!-- Modal For Delete -->
                        <ng-template #Delete let-modal>
                            <div class="p-4 text-center">
                                <div class="position-relative">
                                    <h2 class="text-center text-danger fw-bold">Delete list</h2>
                                    <button type="button" class="position-absolute top-0 end-0 btn-close"
                                        aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
                                </div>
                                <div>
                                    <p class="fs-16">Do you want to delete this list?</p>
                                </div>
                                <div class="d-flex mt-4">
                                    <button type="button" class="btn btn-primary me-1 w-50"
                                        (click)="modal.close('Close click')">Cancel</button>
                                    <button type="button" class="btn btn-outline-primary ms-1 w-50"
                                        (click)="onDelete()">Delete</button>
                                </div>
                            </div>
                        </ng-template>

                        <!-- Modal For Create List -->
                        <ng-template #Create let-modal>
                            <div class="p-4">
                                <div class="position-relative">
                                    <h2 class="text-center fw-bold">Create new list</h2>
                                    <button type="button" class="position-absolute top-0 end-0 btn-close"
                                        aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
                                </div>
                                <div class="position-relative">
                                    <input type="text" [formControl]="createListName" class="input w-100 pe-36"
                                        placeholder="Enter list name">
                                    <i class="bi bi-x-circle-fill clear-icon" (click)="this.createListName.setValue('')"
                                        *ngIf="createListName.value !== ''" role="button"></i>
                                </div>
                                <div class="d-flex mt-4">
                                    <button type="button" class="btn btn-outline-primary me-1 w-50"
                                        (click)="modal.close('Close click')">Cancel</button>
                                    <button type="button" class="btn btn-primary ms-1 w-50" (click)="create()"
                                        [disabled]="createListName.value == ''">Create</button>
                                </div>
                            </div>
                        </ng-template>
                    </tbody>
                </table>
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <h3 class="fs-14">Show {{paginateData.length>0 ? totalData : 0}} of {{paginateData.length>0 ?
                            listNames.length : 0}} items</h3>
                    </div>
                    <div>
                        <ngb-pagination [collectionSize]="paginateData.length>0 ? listNames.length : 0" [maxSize]="3"
                            [(page)]="page" [pageSize]="tableSize" [rotate]="true" [boundaryLinks]="true"
                            (pageChange)="onTableDataChange($event)"></ngb-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>